module.exports = __webpack_public_path__ + "img/career-hero-1.9cb19ba4.svg";